import Head from 'next/head';
import React from 'react';
import { useTranslationContext } from '@/context/translation';
import { localizeSchema } from '@/helpers/localizeSchema';
import { DEFAULT_LOCALE } from '@/constants';

interface AggregateSchemaProps {
	schema: any;
}
export const AggregateSchema: React.FC<AggregateSchemaProps> = ({ schema }) => {
	const { locale } = useTranslationContext();
	const currentLocale = locale || DEFAULT_LOCALE;
	const localizedSchema = localizeSchema(schema, currentLocale, DEFAULT_LOCALE);

	return (
		<Head>
			<script
				type='application/ld+json'
				dangerouslySetInnerHTML={{ __html: JSON.stringify(localizedSchema) }}
			/>
		</Head>
	);
};
